var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 22.05,
    viewBox: "0 0 23.999 22.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "degree-credential",
    d: "M19,1.949H5a5.006,5.006,0,0,0-5,5v10a5.006,5.006,0,0,0,5,5h6.5V19.891A5.946,5.946,0,0,1,10.1,17H6a1,1,0,0,1,0-2h4.082a5.965,5.965,0,0,1,.7-2H6a1,1,0,0,1,0-2h6.614A5.986,5.986,0,0,1,20.5,19.891v1.8A4.991,4.991,0,0,0,24,16.948v-10a5.006,5.006,0,0,0-5-5ZM18,9H6A1,1,0,0,1,6,7H18a1,1,0,0,1,0,2Zm2,7a4,4,0,1,0-6.5,3.1v4.25a.651.651,0,0,0,1.169.4L16,22l1.331,1.743a.651.651,0,0,0,1.169-.4V19.1A3.978,3.978,0,0,0,20,16Z",
    transform: "translate(0 -1.949)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.f67a67c8273f1ddd83d225084450423c.svg";
export { ForwardRef as ReactComponent };